import * as React from "react";
import Invoice, {InvoiceStatus} from "../../../model/invoice/Invoice";
import "../common/commonDetailsStatusRow.scss";
import classNames = require("classnames");

interface IProps {
	/**
	 * Invoice to display status.
	 */
	invoice: Invoice;
}

export const InvoiceStatusRenderer: React.SFC<IProps> = (props) => {
	const invoice = props.invoice;
	switch (invoice.status) {
		case InvoiceStatus.Draft:
			return (
				<div className="c-common-status_status-wrapper">
					<div className="c-common-status_status-text">{invoice.getStatusLabel()}</div>
				</div>
			);
		case InvoiceStatus.PaidNeedsConfirmation:
		case InvoiceStatus.PaidReleasePending:
			const containerClass = classNames({
				"c-common-status_status-wrapper full-background-fill": true,
				"green": invoice.status === InvoiceStatus.PaidNeedsConfirmation
			});
			const triangleClass = classNames({
				"c-common-status_status-wrapper_triangle": true,
				"green": invoice.status === InvoiceStatus.PaidNeedsConfirmation
			});
			return (
				<div className="c-common-status_extended-status-wrapper">
					<div className={containerClass}>
						<div className="c-common-status_status-text white">{invoice.getStatusLabel()[0]}</div>
					</div>
					<div className={triangleClass}/>
					<div className="c-common-status_status-wrapper full-background-fill grey">
						<div className="c-common-status_status-text dark-grey">{invoice.getStatusLabel()[1]}</div>
					</div>
				</div>
			);
		default:
			return (
				<div className="c-common-status_status-wrapper full-background-fill">
					<div className="c-common-status_status-text white">{invoice.getStatusLabel()}</div>
				</div>
			);
	}
};
